<style scoped>
.fade-enter-active
{
  transition-duration: 1s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter{
  opacity: 0
}
</style>

<template>
<div>
	<preloader v-if="loading"></preloader>
	<transition name="fade">
		<router-view v-if="isRouterAlive"></router-view>
	</transition>
</div>
</template>

<script>
import preloader from '@/components/preloader';
import {removeTokenByName} from '@/system/store/cookie';
import {getSessionStorage,setSessionStorage } from '@/system/store/sessionstorage';
import {setLocalStorage, getLocalStorage} from '@/system/store/localstorage';
import locale from 'element-ui/lib/locale'
import en from 'element-ui/lib/locale/lang/en'
import cn from 'element-ui/lib/locale/lang/zh-CN'

export default {
	components:{
		preloader,
	},
	provide(){
		return{
			reload:this.reload,
			preloader:this.preloader,
		}
	},
	data(){
		return{
			loading: false,
			isRouterAlive:true,
		}
	},
	methods:{
		preloader(value){
			this.loading = value;
		},reload(){
            this.isRouterAlive = false
            this.$nextTick(function(){
                this.isRouterAlive = true;
            })
        },
	},created(){
		var lang = (getLocalStorage('currentLang')) ? getLocalStorage('currentLang') : 'cn';
		this.$i18n.locale = lang;
		(lang == 'cn') ? locale.use(cn) : locale.use(en);
	}
}
</script>

